<template>
  <div class="css-jl1qws fukuan d-dialog animate-left-in active" @click.stop="closeTip">
    <div class="sc-bdVaJa keQvRI"></div>
    <input type="file" style="display: none" id="file" @click.stop="0" @change="fileChange()">
    <div class="css-wgk558" :class="{'big-dialog': isSubTitle('样品采购', 'FBA备货申请', 'FBA确认申请', '发货申请')}"
         v-if="proc.data">
      <div class="css-7bwbxg">
        <div class="d-content">
          <header class="c">
            <a v-if="isShowEditBtn" href="javascript:void(0);" class="c a-btn" @click.stop="changeModeCC" @mouseenter="$tip('更新附件')">
              <img src="@/assets/imgs/edit.svg" width="24" height="24">
            </a>
            <a v-print="printObj" href="javascript:void(0);" class="c a-btn" @mouseenter="$tip('打印')">
              <img src="@/assets/imgs/print.svg" width="24" height="24">
            </a>
            <a href="javascript:void(0);" class="c a-btn" title="关闭" @click.stop="closeDialog()">
              <svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation">
                <path
                    d="M12 10.586L6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414L12 10.586z"
                    fill="currentColor"></path>
              </svg>
            </a>
          </header>
          <div class="main-body">
            <!--表单-->
            <div id="print-content" class="main fukuan">
              <div class="invoicMain">
                <div class="invoiceHeader">
                  <div class="headerMiddle">
                    <div class="names">{{ proc.data.title }}</div>
                    <input class="sub-title-inp k" v-model="proc.data.subTitle" placeholder="请输入申请类型" title="申请类型" readonly>
                    <div class="line"></div>
                  </div>
                  <div class="headerLefts">
                    <div class="bumen">
                      <p class="k nowrap">发起部门：</p>
                      <div class="bumen-name-btn nowrap" :class="{err: isFormValid && err.bumen}" @click.stop="showBumenSelectorAndLoad('bumens');">
                        <span class="nowrap">{{ proc.data.bumen || '请选择部门' }}</span>
                        <div class="bottom-active">
                          <slide-x-left-transition>
                            <SelectBumen :list="itemList.bumens" :callback="setBumenAndLoadZhuguan" v-show="isShowList('bumens')" position="bottom"></SelectBumen>
                          </slide-x-left-transition>
                        </div>
                      </div>
                    </div>
                    <div class="d-date">
                      <div class="day" @click="openDatePicker()" :disabled="!isEditMode">
                        <u>{{ fdate(proc.data.createDate, 'yyyy') }}</u>
                        <p>年</p>
                        <u>{{ fdate(proc.data.createDate, 'MM') }}</u>
                        <p>月</p>
                        <u>{{ fdate(proc.data.createDate, 'dd') }}</u>
                        <p>号</p>
                      </div>
                      <date-picker v-model="proc.data.createDate" valueType="format" @confirm="isShowDatePicker = false" :confirm="true" :open="isShowDatePicker"></date-picker>
                    </div>
                    <div class="zihao">
                      <p>{{ proc.data.zi }}</p>
                      <label>字</label>
                    </div>
                  </div>
                </div>
                <div class="body">
                  <div class="flexLeft">
                    <div class="bodylen">标准会计凭证系列</div>
                  </div>
                  <div v-if="proc.data.subTitle === '出差申请'" class="d-form cqxj">
                    <div class="bodyf">
                      <div class="tablest">
                        <!--出差申请 部门、姓名、职务、目的地-->
                        <div class="biaoge">
                          <div class="titles">出差申请人</div>
                          <div class="neiron">
                            <p class="k">部门</p>
                            <input v-if="isEditMode" type="text" value="" v-model="proc.data.bumen" :disabled="!isEditMode">
                            <p v-if="!isEditMode" class="m05">{{ proc.data.bumen }}</p>
                            <p class="k">姓名</p>
                            <input v-if="isEditMode" type="text" value="" v-model="proc.data.startUser.name" :disabled="!isEditMode">
                            <p v-if="!isEditMode" class="m05">{{ proc.data.startUser.name }}</p>
                            <p class="k">职务</p>
                            <input v-if="isEditMode" type="text" value="" v-model="proc.data.zhiwu" :disabled="!isEditMode">
                            <p v-if="!isEditMode" class="m05">{{ proc.data.zhiwu }}</p>
                            <p class="k">出差目的地</p>
                            <input v-if="isEditMode" type="text" value="" v-model="proc.data.mudi" :disabled="!isEditMode">
                            <p v-if="!isEditMode" class="m05">{{ proc.data.mudi }}</p>
                          </div>
                        </div>
                        <!--出差申请 预计出差时间-->
                        <div class="biaoge">
                          <div class="titles">预计出差时间</div>
                          <div class="neiron">
                            <div class="day" @click="pickerDay(proc.data, 'startDate')" :disabled="!isEditMode">
                              <u>{{ fdate(proc.data.startDate, 'yyyy') }}</u>
                              <p>年</p>
                              <u>{{ fdate(proc.data.startDate, 'MM') }}</u>
                              <p>月</p>
                              <u>{{ fdate(proc.data.startDate, 'dd') }}</u>
                              <p>号</p>
                            </div>
                            <p class="k">至</p>
                            <div class="day" @click="pickerDay(proc.data, 'endDate')" :disabled="!isEditMode">
                              <u>{{ fdate(proc.data.endDate, 'yyyy') }}</u>
                              <p>年</p>
                              <u>{{ fdate(proc.data.endDate, 'MM') }}</u>
                              <p>月</p>
                              <u>{{ fdate(proc.data.endDate, 'dd') }}</u>
                              <p>号</p>
                            </div>
                            <p class="k">共计</p>
                            <input type="text" value="" v-model="proc.data.day" :disabled="!isEditMode" style="width: 50px;">
                            <p class="k">天</p>
                          </div>
                        </div>
                        <!--出差申请 出差日程安排-->
                        <div class="biaoge" v-if="proc.data.title === '出差申请'">
                          <div class="titles d-checkbox">出差日程安排</div>
                          <div class="neiron d-checkbox fd-c">
                            <div class="d-c" v-for="(ap, i) in proc.data.anpai" :key="i">
                              <p class="k">第</p>
                              <input v-if="isEditMode" type="text" value="" v-model="ap.day" :disabled="!isEditMode" style="width: 50px;">
                              <p v-if="!isEditMode" class="m05">{{ ap.day }}</p>
                              <p class="k">天，</p>
                              <input v-if="isEditMode" type="text" value="" v-model="ap.anpai" :disabled="!isEditMode">
                              <p v-if="!isEditMode" class="m05">{{ ap.anpai }}</p>
                              <img alt="" src="../assets/imgs/push1.svg" class="icon-small icon-add" v-if="i == proc.data.anpai.length - 1 && isEditMode" @click="addAnpai">
                            </div>
                          </div>
                        </div>
                        <!--出差申请 出差事由-->
                        <div class="biaoge">
                          <div class="titles d-checkbox">出差事由</div>
                          <div class="neiron d-checkbox">
                            <input type="text" value="" v-model="proc.data.yuanyin" :disabled="!isEditMode">
                          </div>
                        </div>
                        <!--出差申请 乘坐交通-->
                        <div class="biaoge">
                          <div class="titles d-checkbox">乘坐交通</div>
                          <div class="neiron d-checkbox jiaotong">
                            <div class="d-c" data-id="jiaotongGo">
                              <p class="k">去：</p>
                              <input id="qc-g" type="checkbox" value="汽车" name="qc-g" v-model="proc.data.jiaotongGo" :disabled="!isEditMode">
                              <label for="qc-g">汽车</label>
                              <input id="hc-g" type="checkbox" value="火车" name="hc-g" v-model="proc.data.jiaotongGo" :disabled="!isEditMode">
                              <label for="hc-g">火车</label>
                              <input id="cb-g" type="checkbox" value="船舶" name="cb-g" v-model="proc.data.jiaotongGo" :disabled="!isEditMode">
                              <label for="cb-g">船舶</label>
                              <input id="fj-g" type="checkbox" value="飞机" v-model="proc.data.jiaotongGo" :disabled="!isEditMode">
                              <label for="fj-g">飞机</label>
                              <input id="zj-g" type="checkbox" value="自驾车" v-model="proc.data.jiaotongGo" :disabled="!isEditMode">
                              <label for="zj-g">自驾车</label>
                            </div>
                            <div class="d-c" data-id="jiaotongBack">
                              <p class="k">回：</p>
                              <input id="qc-b" type="checkbox" value="汽车" v-model="proc.data.jiaotongBack" :disabled="!isEditMode">
                              <label for="qc-b">汽车</label>
                              <input id="hc-b" type="checkbox" value="火车" v-model="proc.data.jiaotongBack" :disabled="!isEditMode">
                              <label for="hc-b">火车</label>
                              <input id="cb-b" type="checkbox" value="船舶" v-model="proc.data.jiaotongBack" :disabled="!isEditMode">
                              <label for="cb-b">船舶</label>
                              <input id="fj-b" type="checkbox" value="飞机" v-model="proc.data.jiaotongBack" :disabled="!isEditMode">
                              <label for="fj-b">飞机</label>
                              <input id="zj-b" type="checkbox" value="自驾车" v-model="proc.data.jiaotongBack" :disabled="!isEditMode">
                              <label for="zj-b">自驾车</label>
                            </div>
                          </div>
                        </div>
                        <!--出差申请 费用预算-->
                        <div class="biaoge">
                          <div class="titles d-checkbox">费用预算</div>
                          <div class="neiron neiron-ys">
                            <div class="feiyong-title">
                              <div class="k">交通费</div>
                              <div class="k">住宿费</div>
                              <div class="k">餐费</div>
                              <div class="k">业务招待费</div>
                              <div class="k">其他费用</div>
                              <div class="k">合计（元）</div>
                            </div>
                            <div class="feiyong-content">
                              <div class="c">
                                <input :type="isEditMode ? 'number' : 'text'" value="" @change="yusuanHeji" v-model="proc.data.feiyongYusuan.jiaotong" :disabled="!isEditMode"></div>
                              <div class="c"><input :type="isEditMode ? 'number' : 'text'" value="" @change="yusuanHeji" v-model="proc.data.feiyongYusuan.zhusu"
                                                    :disabled="!isEditMode"></div>
                              <div class="c"><input :type="isEditMode ? 'number' : 'text'" value="" @change="yusuanHeji" v-model="proc.data.feiyongYusuan.canfei"
                                                    :disabled="!isEditMode"></div>
                              <div class="c"><input :type="isEditMode ? 'number' : 'text'" value="" @change="yusuanHeji" v-model="proc.data.feiyongYusuan.yewu" :disabled="!isEditMode">
                              </div>
                              <div class="c"><input :type="isEditMode ? 'number' : 'text'" value="" @change="yusuanHeji" v-model="proc.data.feiyongYusuan.qita" :disabled="!isEditMode">
                              </div>
                              <div class="c"><input :type="isEditMode ? 'number' : 'text'" value="" @change="yusuanHeji" v-model="proc.data.jine" disabled="disabled"></div>
                            </div>
                          </div>
                        </div>
                        <!--出差申请 预借费用-->
                        <div class="biaoge">
                          <div class="titles d-checkbox">预借费用</div>
                          <div class="neiron">
                            <div class="feiyong-content">
                              <div class="c"><input :type="isEditMode ? 'number' : 'text'" value="" @change="yujieHeji" v-model="proc.data.feiyongYujie.jiaotong"
                                                    :disabled="!isEditMode"></div>
                              <div class="c"><input :type="isEditMode ? 'number' : 'text'" value="" @change="yujieHeji" v-model="proc.data.feiyongYujie.zhusu" :disabled="!isEditMode">
                              </div>
                              <div class="c"><input :type="isEditMode ? 'number' : 'text'" value="" @change="yujieHeji" v-model="proc.data.feiyongYujie.canfei" :disabled="!isEditMode">
                              </div>
                              <div class="c"><input :type="isEditMode ? 'number' : 'text'" value="" @change="yujieHeji" v-model="proc.data.feiyongYujie.yewu" :disabled="!isEditMode">
                              </div>
                              <div class="c"><input :type="isEditMode ? 'number' : 'text'" value="" @change="yujieHeji" v-model="proc.data.feiyongYujie.qita" :disabled="!isEditMode">
                              </div>
                              <div class="c"><input :type="isEditMode ? 'number' : 'text'" value="" @change="yujieHeji" v-model="proc.data.feiyongYujie.jine" disabled="disabled"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else="" class="d-form">
                    <div v-if="isSubTitle('样品采购', 'FBA备货申请', 'FBA确认申请', '发货申请')" class="bodyf d-form ypcg">
                      <div>
                        <div class="tablest">
                          <table class="tb-ypcg" border="0" cellpadding="0" cellspacing="0">
                            <tr class="title">
                              <td height="40" v-for="(ff, i) in FbaFormFields[proc.data.title][proc.data.subTitle]" :key="i">{{ ff.name }}</td>
                              <td v-if="isEditMode"></td>
                            </tr>
                            <tr v-for="(cg, cgi) in proc.data.caigous" :key="cgi">
                              <td v-for="(ff, ffi) in FbaFormFields[proc.data.title][proc.data.subTitle]" @click.stop="!ff.readonly && editField(cgi, ff.key)" :readonly="ff.readonly" :key="ffi">
                                <div class="edit-field" v-if="!isEditField(cgi, ff.key)" :class="{num: ff.type == 'number'}" v-text="cg[ff.key]"></div>
                                <div>
                                  <textarea :id="'textarea-' + cgi + '-' + ff.key" @click.stop="0" class="edit-field" v-if="isEditField(cgi, ff.key)" v-model="editFieldValue"></textarea>
                                </div>
                              </td>
                              <td v-if="isEditMode"><img alt="" src="../assets/imgs/push1.svg" class="icon-small icon-add" @click="addCaigouItem" v-if="cgi + 1 == proc.data.caigous.length"></td>
                            </tr>
                          </table>
                          <table class="tb-ypcg tb-fba-other" border="0" cellpadding="0" cellspacing="0" v-if="isSubTitle('FBA备货申请')">
                            <tr class="title">
                              <td height="40" v-for="(fo, foi) in FbaFormFields['其他']['FBAOther']" :key="foi">{{ fo.name }}</td>
                            </tr>
                            <tr>
                              <td @click.stop="editField(proc.data, fo.key)" v-for="(fo, foi) in FbaFormFields['其他']['FBAOther']" height="40" :key="foi">
                                <div class="edit-field" v-if="!isEditField(proc.data, fo.key)" v-text="proc.data[fo.key]"></div>
                                <div>
                                  <textarea :id="'textarea-other-' + fo.key" @click.stop="0" class="edit-field" v-if="isEditField(proc.data, fo.key)" v-model="editFieldValue"></textarea>
                                </div>
                              </td>
                            </tr>
                          </table>
                          <div class="biaoge" v-if="isProc('其他', '样品采购')">
                            <div class="titles required">预估运费合计</div>
                            <div class="neiron">
                              <input v-if="isEditMode" :type="isEditMode ? 'number' : 'text'" v-model="proc.data.yunfeijine" :class="{err: isFormValid && err.yunfeijine}"
                                     readonly disabled>
                              <p v-if="!isEditMode" class="m05">{{ proc.data.yunfeijine }}</p>
                            </div>
                          </div>
                          <div class="biaoge" v-if="isSubTitle('FBA备货申请', '发货申请')">
                            <div class="titles required">预估采购单金额合计</div>
                            <div class="neiron">
                              <input v-if="isEditMode" :type="isEditMode ? 'number' : 'text'" v-model="proc.data.jineheji" :class="{err: isFormValid && err.jineheji}"
                                     readonly disabled>
                              <p v-if="!isEditMode" class="m05">{{ proc.data.jineheji }}</p>
                            </div>
                          </div>
                          <div class="biaoge" v-if="isSubTitle('FBA备货申请', '发货申请')">
                            <div class="titles required">预估发货运费金额合计</div>
                            <div class="neiron">
                              <input v-if="isEditMode" :type="isEditMode ? 'number' : 'text'" v-model="proc.data.yunfeijine" :disabled="!isEditMode"
                                     :class="{err: isFormValid && err.yunfeijine}" @change="computeYpcgJine()">
                              <p v-if="!isEditMode" class="m05">{{ proc.data.yunfeijine }}</p>
                            </div>
                          </div>
                          <div class="biaoge">
                            <div class="titles required">预估本申请单金额总计</div>
                            <div class="neiron">
                              <slide-x-left-transition>
                                <SelectCurrency :cur-show-list="curShowList" :currency="proc.data.currency" :is-edit-mode="isEditMode"
                                                :callback="(currency)=>{this.proc.data.currency = currency; this.curShowList = ''}"></SelectCurrency>
                              </slide-x-left-transition>
                              <input v-if="isEditMode" :type="isEditMode ? 'number' : 'text'" value="" v-model="proc.data.jine" :class="{err: isFormValid && err.jine}"
                                     readonly disabled>
                              <p v-if="!isEditMode" class="m05">{{ proc.data.jine }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="bodyf">
                      <div v-if="proc.data.title !== '报销申请'" class="tablest" id="fk">
                        <!--收款单位-->
                        <div class="biaoge" v-if="isCanShowPayFields()">
                          <div class="titles required">收款单位</div>
                          <div class="neiron">
                            <input type="text" value="" v-model="proc.data.shoukuan" :disabled="!isEditMode" :class="{err: isFormValid && err.shoukuan}" @change="validForm">
                          </div>
                        </div>
                        <!--收款账号-->
                        <div class="biaoge" v-if="isCanShowPayFields()">
                          <div class="titles">收款账号</div>
                          <div class="neiron">
                            <input type="text" value="" v-model="proc.data.zhanghao" :disabled="!isEditMode">
                          </div>
                        </div>
                        <!--开户行-->
                        <div class="biaoge" v-if="isCanShowPayFields()">
                          <div class="titles">开户行</div>
                          <div class="neiron">
                            <input type="text" value="" v-model="proc.data.kaihuhang" :disabled="!isEditMode">
                          </div>
                        </div>
                        <!--付款内容-->
                        <div class="biaoge" v-if="proc.data.subTitle === '付款申请'">
                          <div class="titles">付款内容</div>
                          <div class="neiron">
                            <input type="text" value="" v-model="proc.data.fukuanNeirong" :disabled="!isEditMode">
                          </div>
                        </div>
                        <!--采购清单-->
                        <div class="biaoge" v-if="proc.data.subTitle === '供应链采购'">
                          <div class="titles d-checkbox required">采购清单</div>
                          <div class="neiron d-checkbox fd-c">
                            <div class="d-c" v-for="(kx, iCG) in proc.data.caigouQingdanGyl" :key="iCG">
                              <input v-if="isEditMode" type="text" placeholder="采购商品名" title="采购商品名" class="name-btn" v-model="kx.name" :class="{err: isFormValid && !kx.name}"
                                     :disabled="!isEditMode">
                              <p v-if="!isEditMode" class="m05">{{ kx.name }}</p>
                              <input v-if="isEditMode" type="text" placeholder="单价" title="单价" class="price-btn" v-model="kx.danjia" @change="jisuanHejiGyl('danjia', iCG)"
                                     :class="{err: isFormValid && !kx.danjia}" :disabled="!isEditMode">
                              <p v-if="!isEditMode" class="m05">{{ kx.danjia }}</p>
                              <input v-if="isEditMode" type="number" placeholder="采购量" title="采购量" class="price-btn" v-model="kx.shuliang" @change="jisuanHejiGyl('shuliang', iCG)"
                                     :class="{err: isFormValid && !kx.shuliang}" :disabled="!isEditMode">
                              <p v-if="!isEditMode" class="m05">* {{ kx.shuliang }}</p>
                              <img alt="" src="../assets/imgs/push1.svg" class="icon-small icon-add" v-if="iCG == proc.data.caigouQingdanGyl.length - 1 && isEditMode" @click="addcaigouQingdanGyl">
                            </div>
                          </div>
                        </div>
                        <!--采购内容-->
                        <div class="biaoge" v-if="proc.data.subTitle == '日常采购'">
                          <div class="titles">采购内容</div>
                          <div class="neiron">
                            <input type="text" value="" v-model="proc.data.caigouNeirong" :disabled="!isEditMode">
                          </div>
                        </div>
                        <!--推广内容-->
                        <div class="biaoge" v-if="proc.data.subTitle == '推广申请'">
                          <div class="titles">推广内容</div>
                          <div class="neiron">
                            <input type="text" value="" v-model="proc.data.tuiguangNeirong" :disabled="!isEditMode">
                          </div>
                        </div>
                        <!--租金水电月份-->
                        <div class="biaoge" v-if="proc.data.subTitle == '租金水电'">
                          <div class="titles">租金水电月份</div>
                          <div class="neiron d-ym">
                            <input v-if="isEditMode" type="number" v-model="proc.data.zujinShuidianYear" :disabled="!isEditMode" min="1997" max="2050">
                            <p v-if="!isEditMode" class="m05 ml16">{{ proc.data.zujinShuidianYear }}</p>
                            年
                            <input v-if="isEditMode" type="number" v-model="proc.data.zujinShuidianMonth" :disabled="!isEditMode" min="1" max="12">
                            <p v-if="!isEditMode" class="m05">{{ proc.data.zujinShuidianMonth }}</p>
                            月
                          </div>
                        </div>
                        <!--服务器充值/服务器购买/服务器续费 服务商-->
                        <div class="biaoge" v-if="proc.data.subTitle && (proc.data.subTitle == '服务器充值' || proc.data.subTitle == '服务器购买'|| proc.data.subTitle == '服务器续费')">
                          <div class="titles">服务商</div>
                          <div class="neiron">
                            <input type="radio" value="阿里云" id="ali" v-model="proc.data.fuwushang" :disabled="!isEditMode"
                                   @click.stop="isEditMode && (proc.data.fuwushang = '阿里云')">
                            <label for="ali" @click.stop="isEditMode && (proc.data.fuwushang = '阿里云')">阿里云</label>
                            <input type="radio" value="百度云" id="baidu" v-model="proc.data.fuwushang" :disabled="!isEditMode"
                                   @click.stop="isEditMode && (proc.data.fuwushang = '百度云')">
                            <label for="baidu" @click.stop="isEditMode && (proc.data.fuwushang = '百度云')">百度云</label>
                            <input type="radio" value="Godaddy" id="godaddy" v-model="proc.data.fuwushang" :disabled="!isEditMode"
                                   @click.stop="isEditMode && (proc.data.fuwushang = 'Godaddy')">
                            <label for="godaddy" @click.stop="isEditMode && (proc.data.fuwushang = 'Godaddy')">Godaddy</label>
                          </div>
                        </div>
                        <!--服务器充值/服务器购买/服务器续费 服务器账号-->
                        <div class="biaoge" v-if="proc.data.subTitle && (proc.data.subTitle == '服务器充值' || proc.data.subTitle == '服务器购买'|| proc.data.subTitle == '服务器续费')">
                          <div class="titles">服务器账号</div>
                          <div class="neiron s-a-inp">
                            <input type="text" value="" v-model="proc.data.serverZhanghao" :disabled="!isEditMode" placeholder="阿里云/百度云账号" title="阿里云/百度云账号"
                                   @click.stop="showItemList('serverAccount')">
                            <slide-x-left-transition>
                              <div class="bottom-active" v-show="isShowList('serverAccount')">
                                <div class="menu">
                                  <div class="m-item" @click.stop="setServerAccount(sa); " v-for="(sa, i) in itemList.serverAccount" :key="i">
                                    <span class="group">{{ sa.server }}</span>{{ sa.account }}
                                  </div>
                                </div>
                              </div>
                            </slide-x-left-transition>
                          </div>
                        </div>
                        <!--周期结算/工资/社保/公积金/物流费结算 结算月份-->
                        <div class="biaoge"
                             v-if="proc.data.title == '周期结算' || proc.data.subTitle == '工资' || proc.data.subTitle == '社保' || proc.data.subTitle == '公积金' || proc.data.subTitle == '物流费结算'">
                          <div class="titles d-checkbox">结算月份</div>
                          <div class="neiron d-ym">
                            <div>
                              <input v-if="isEditMode" type="number" v-model="proc.data.jiesuanYear" :disabled="!isEditMode" min="1997" max="2050">
                              <p v-if="!isEditMode" class="m05 ml16">{{ proc.data.jiesuanYear }}</p>
                              年
                            </div>
                            <div v-if="!(proc.data.title == '付款申请' && proc.data.subTitle == '物流费结算')">
                              <input v-if="isEditMode" type="number" v-model="proc.data.jiesuanMonth" :disabled="!isEditMode" min="1" max="12">
                              <p v-if="!isEditMode" class="m05">{{ proc.data.jiesuanMonth }}</p>
                              月
                            </div>
                          </div>
                        </div>
                        <!--周期结算 结算款项-->
                        <div class="biaoge" v-if="proc.data.title === '周期结算'">
                          <div class="titles d-checkbox required">结算款项</div>
                          <div class="neiron d-checkbox fd-c">
                            <div class="d-c" v-for="(kx, i) in proc.data.kuanxiangs" :key="i">
                              <input v-if="isEditMode" type="text" placeholder="款项" title="款项" class="name-btn" v-model="kx.name" :class="{err: i == 0 && isFormValid && err.kxName}"
                                     @change="validForm('fukuan')" :disabled="!isEditMode">
                              <p v-if="!isEditMode" class="m05 ml16">{{ kx.name }}</p>
                              <input v-if="isEditMode" :type="isEditMode ? 'number' : 'text'" placeholder="金额" title="金额" class="price-btn" v-model="kx.jine" @change="jiesuanHeji"
                                     :class="{err: i == 0 && isFormValid && err.kxJine}" :disabled="!isEditMode">
                              <p v-if="!isEditMode" class="m05">{{ kx.jine }}</p>
                              <div class="part-select" :class="{err: isFormValid && err.bumen}" @click.stop="showBumenSelectorAndLoad(`bumens-${i}`);">
                                <div class="c">
                                  <span>{{ kx.bumen || '请选择部门' }}</span>
                                  <img alt="" src="../assets/imgs/triangle.png" class="icon-small" v-if="isEditMode">
                                </div>
                                <div class="bottom-active">
                                  <slide-x-left-transition>
                                    <SelectBumen :list="itemList.bumens" :callback="setZhouqijiesuanKxBumen" v-show="isShowList(`bumens-${i}`)" position="bottom" :index="i"></SelectBumen>
                                  </slide-x-left-transition>
                                </div>
                              </div>
                              <img alt="" src="../assets/imgs/push1.svg" class="icon-small icon-add" v-if="i == proc.data.kuanxiangs.length - 1 && isEditMode" @click="addKuanxiang">
                            </div>
                          </div>
                        </div>
                        <!--付款申请-工资/社保/公积金 物流费结算 结算款项-->
                        <div class="biaoge"
                             v-if="proc.data.title == '付款申请' && (proc.data.subTitle == '工资' || proc.data.subTitle == '社保' || proc.data.subTitle == '公积金' || proc.data.subTitle == '物流费结算')">
                          <div class="titles d-checkbox required">结算款项</div>
                          <div class="neiron d-checkbox fd-c">
                            <div class="d-c" v-for="(kx, i) in proc.data.kuanxiangsGz" :key="i" :index-kx="i">
                              <div class="part-select c" @click.stop="showBumenSelectorAndLoad(`bumens-kx-${i}`) " :class="{err: isFormValid && !kx.bumen}">
                                {{ kx.bumen || '选择部门' }}
                                <img alt="" src="../assets/imgs/triangle.png" class="icon-small" v-if="isEditMode">
                                <slide-x-left-transition>
                                  <SelectBumen :list="itemList[`bumens-kx-${i}`]" :callback="setKxBumen" v-show="isShowList(`bumens-kx-${i}`)" position="bottom" :index="i"></SelectBumen>
                                </slide-x-left-transition>
                              </div>
                              <input v-if="isEditMode" :type="isEditMode ? 'number' : 'text'" placeholder="金额" title="金额" class="price-btn" v-model="kx.jine" @change="jiesuanHejiGz"
                                     :class="{err: isFormValid && !kx.jine}" :disabled="!isEditMode">
                              <p v-if="!isEditMode" class="m05">{{ kx.jine }}</p>
                              <div class="pr" @click.stop="isTaskName('财务复核') || isTaskName('出纳付款') && showItemListPayAccount(`payAccount-${i}`)"
                                   v-if="isTaskName('财务复核') || isTaskName('出纳付款') || proc.isEnd && kx.payAccount">
                                <input type="text" placeholder="备注付款账号" title="备注付款账号" class="name-btn p-a-inp" v-model="kx.payAccount" :disabled="!isTaskName('财务复核') && !isTaskName('出纳付款')"
                                       :class="{cp: isTaskName('财务复核') || isTaskName('出纳付款')}">
                                <slide-x-left-transition>
                                  <SelectText :list="itemList.payAccount" v-show="isShowList(`payAccount-${i}`)" :callback="setKxPayAccount"></SelectText>
                                </slide-x-left-transition>
                              </div>
                              <img alt="" src="../assets/imgs/push1.svg" class="icon-small icon-add" v-if="i == proc.data.kuanxiangsGz.length - 1 && isEditMode" @click="addKuanxiangGz">
                            </div>
                          </div>
                        </div>
                        <!--金额大写-->
                        <div class="biaoge">
                          <div class="titles">金额大写</div>
                          <div class="neiron daxie">
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[0] }}</div>
                            <div>佰</div>
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[1] }}</div>
                            <div>拾</div>
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[2] }}</div>
                            <div>万</div>
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[3] }}</div>
                            <div>仟</div>
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[4] }}</div>
                            <div>佰</div>
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[5] }}</div>
                            <div>拾</div>
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[6] }}</div>
                            <div>元</div>
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[7] }}</div>
                            <div>角</div>
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[8] }}</div>
                            <div>分</div>
                          </div>
                        </div>
                        <!--金额小写-->
                        <div class="biaoge">
                          <div class="titles required">金额小写</div>
                          <div class="neiron">
                            <slide-x-left-transition>
                              <SelectCurrency :cur-show-list="curShowList" :currency="proc.data.currency" :is-edit-mode="isEditMode"
                                              :callback="(currency)=>{this.proc.data.currency = currency; this.curShowList = ''}"></SelectCurrency>
                            </slide-x-left-transition>
                            <input v-if="isEditMode" :type="isEditMode ? 'number' : 'text'" value="" v-model="proc.data.jine" :disabled="!isEditMode" :class="{err: isFormValid && err.jine}"
                                   @change="jineChange" id="jine" step="0.01">
                            <p v-if="!isEditMode" class="m05">{{ proc.data.jine }}</p>
                          </div>
                        </div>
                      </div>
                      <div v-else class="tablest" id="bx">
                        <div class="biaoge">
                          <div class="titles required">领款人</div>
                          <div class="neiron">
                            <input type="text" value="" class="" v-model="proc.data.lingkuanren" :disabled="!isEditMode" :class="{err: isFormValid && err.lingkuanren}"
                                   @change="validForm('baoxiao')">
                          </div>
                        </div>
                        <div class="biaoge">
                          <div class="titles ytname required">用途</div>
                          <div class="neiron yts">
                            <div class="d-checkbox">
                              <div class="d-c" v-for="(yy, i) in proc.data.yongtus" :key="i">
                                <input v-if="isEditMode" type="text" placeholder="用途" title="用途" class="name-btn" v-model="yy.name" :disabled="!isEditMode"
                                       :class="{err: isFormValid && !yy.name}">
                                <p v-if="!isEditMode" class="m05">{{ yy.name }}</p>
                                <input v-if="isEditMode" :type="isEditMode ? 'number' : 'text'" placeholder="金额" title="金额" class="price-btn" v-model="yy.jine"
                                       :disabled="!isEditMode" :class="{err: isFormValid && !yy.jine}" @change="baoxiaoHeji">
                                <p v-if="!isEditMode" class="m05">{{ yy.jine }}</p>
                                <img alt="" v-if="isEditMode && i == proc.data.yongtus.length - 1" @click="addYongtu" src="@/assets/imgs/push1.svg" class="icon-small icon-add">
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="biaoge">
                          <div class="titles title1"><p></p>
                            <p></p>
                            <p class="k">合</p>
                            <p></p>
                            <p class="k">计</p>
                            <p></p>
                            <p></p></div>
                          <div class="neiron">
                            <slide-x-left-transition>
                              <SelectCurrency :cur-show-list="curShowList" :currency="proc.data.currency" :is-edit-mode="isEditMode"
                                              :callback="(currency)=>{this.proc.data.currency = currency; this.curShowList = ''}"></SelectCurrency>
                            </slide-x-left-transition>
                            <input v-if="isEditMode" :type="isEditMode ? 'number' : 'text'" value="" v-model="proc.data.jine" disabled="true"
                                   :class="{err: isFormValid && err.jine}">
                            <p v-if="!isEditMode" class="m05">{{ proc.data.jine }}</p>
                          </div>
                        </div>
                        <div class="biaoge">
                          <div class="titles">金额大写</div>
                          <div class="neiron daxie">
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[0] }}</div>
                            <div>佰</div>
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[1] }}</div>
                            <div>拾</div>
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[2] }}</div>
                            <div>万</div>
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[3] }}</div>
                            <div>仟</div>
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[4] }}</div>
                            <div>佰</div>
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[5] }}</div>
                            <div>拾</div>
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[6] }}</div>
                            <div>元</div>
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[7] }}</div>
                            <div>角</div>
                            <div>{{ proc.data.jineDaxie && proc.data.jineDaxie[8] }}</div>
                            <div>分</div>
                          </div>
                        </div>
                        <div class="biaoge">
                          <div class="titles">原借款</div>
                          <div class="neiron">
                            <input type="text" value="" class="" v-model="proc.data.yuanjiekuan" @change="baoxiaoHeji" :disabled="!isEditMode">
                          </div>
                        </div>
                        <div class="biaoge">
                          <div class="titles">应退余款</div>
                          <div class="neiron"><input type="text" value="" class="" v-model="proc.data.yingtuikuan" disabled="true"></div>
                        </div>
                      </div>
                      <div class="bootmRefih">
                        <div class="bootmTops">
                          <div>备</div>
                          <div></div>
                          <div></div>
                          <div>注</div>
                        </div>
                        <div class="bootmRefih-top"><textarea class="yy" v-model="proc.data.yuanyin" :disabled="!isEditMode"></textarea></div>
                      </div>
                    </div>
                    <div class="fj">
                      <div class="titles c">附件</div>
                      <div class="d-fjs">
                        <div v-for="(fj, i) in proc.data.fujians" @mouseenter="$tip(fj.replace(/\/upload\/fujian[\\\\\/]/g, ''))" :key="i">
                          <a v-if="!isImg(fj)" :href="oss + fj" class="d-fj-img c" target="_blank">
                            <img alt="" class="del-icon" src="../assets/imgs/fail.svg" @click.stop="delFj(i)" v-if="canUploadFujian()">
                          </a>
                          <div v-else class="d-fj-img c" @click="openImgViewer(i)">
                            <img alt="" class="fj-img" :src="getFujianShowSrc(fj)" :data-original="getFujianShowSrc(fj)">
                            <img alt="" class="del-icon" src="../assets/imgs/fail.svg" @click.stop="delFj(i)" v-if="canUploadFujian()">
                          </div>
                        </div>
                        <div class="add-btn c" @click="addFujian()" v-if="canUploadFujian()"
                             @mouseenter="$tip('支持 Ctrl + V 一键上传截图哦')">
                          <svg t="1592449769161" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4699" xmlns:xlink="http://www.w3.org/1999/xlink"
                               width="108"
                               height="108">
                            <path d="M512 929a44 44 0 0 1-44-44V143a44 44 0 0 1 88 0v742a44 44 0 0 1-44 44z" p-id="4700"></path>
                            <path d="M883 558H141a44 44 0 0 1 0-88h742a44 44 0 0 1 0 88z" p-id="4701"></path>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flexLeft bodylen">
                    附件 {{ proc.data.fujians ? proc.data.fujians.length : 0 }} 张
                  </div>
                </div>
                <!--抄送单个(旧版本)-->
                <div class="d-cs" v-if="proc.data.chaosongUser && proc.data.chaosongUser.name">
                  <div class="k">抄送</div>
                  <div class="d-cs-user c">
                    <img alt="" v-if="proc.data.chaosongUser.img" :src="baseURL + proc.data.chaosongUser.img" class="profile">
                    <span v-else class="profile name-avatar" :style="{ background: avatarColor(proc.data.chaosongUser.name) }">{{ avatarInitial(proc.data.chaosongUser.name) }}</span>
                    <input v-model="proc.data.chaosongUser.name" disabled>
                  </div>
                </div>
                <!--抄送多个-->
                <div class="d-cs" v-if="isEditMode || proc.data.chaosongsUser && proc.data.chaosongsUser.length">
                  <div class="k nowrap">抄送</div>
                  <div class="d-cs-user c">
                    <div class="d-inp-cs" @click.stop="showItemList( 'users');" v-if="isEditMode">
                      <input v-model="chaosongsUsername" @input="updateNowChaosongsUsername" :disabled="!isEditMode" @keyup.enter="addChaosongsUserByName">
                      <img alt="" src="../assets/imgs/ok-black.svg" class="sm-close" @click.stop="addChaosongsUserByName">
                      <slide-x-left-transition>
                        <SelectUser :list="filterChaosongsUser()" :unShowGroup="true" :callback="addChaosongsUser" v-show="isShowList('users')"></SelectUser>
                      </slide-x-left-transition>
                    </div>
                    <div class="cs-img-name c" v-for="(csUser, csi) in proc.data.chaosongsUser" :key="csi">
                      <img alt="" v-if="csUser.img" :src="baseURL + csUser.img" class="profile">
                      <span v-else class="profile name-avatar" :style="{ background: avatarColor(csUser.name) }">{{ avatarInitial(csUser.name) }}</span>
                      {{ csUser.name }}
                      <img src="../assets/imgs/close.svg" class="sm-close" v-if="isEditMode" @click.stop="removeChaosongsUser(csi)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--动态流程图 V1-->
            <div class="proc" v-if="proc && proc.data">
              <div class="jd" v-for="(node, iNode) in nodeShowByProc" :key="iNode" v-show="isShowNode(node.key)">
                <div class="e" :class="{'disable': !isEditMode && isNodeTodo(node.key)}">
                  <div><img :alt="node.name" class="icon node-status-img" :src="getStatusImg(node.key)"></div>
                  <div class="e-name" @mouseenter="node.tip && $tip(node.tip)">{{ node.name }}</div>
                </div>
                <div class="n" v-if="iNode !== nodes.all.length - 1">
                  <div class="l" :class="iNode == 0 && 'disable'"></div>
                  <div :class="[node.userKey && node.groupId ? 'd-user' : '', isFormValid && err[`${node.userKey}.name`] && 'err', !isEditMode && 'disable', !node.userKey && 'no-user-key']"
                       @click.stop="node.groupId && isEditMode && showItemList(node.userKey, false, node.userKey + '-' + iNode)">
                    <img alt="" v-if="getUserImg(node.userKey)" :src="getUserImg(node.userKey)" class="profile">
                    <span v-else-if="getUsername(node.userKey)" class="profile name-avatar" :style="{ background: avatarColor(getUsername(node.userKey)) }">{{ avatarInitial(getUsername(node.userKey)) }}</span>
                    <img alt="" v-else :src="userUnLoginImg" class="profile">
                    <p>{{ getUsername(node.userKey) }}</p>
                    <img alt="" src="../assets/imgs/triangle.png" v-if="node.groupId && isEditMode" class="icon-jiantou">
                    <slide-x-left-transition>
                      <SelectUser :list="itemList[node.userKey]" v-show="isShowList(node.userKey + '-' + iNode)" :callback="setUser"></SelectUser>
                    </slide-x-left-transition>
                  </div>
                </div>
              </div>
            </div>
            <!--提交、审批通过、确认签收 等按钮-->
            <div class="main " v-if="(isTaskDefKey('chunaFukuan') || isTaskDefKey('fbaCaigouquerenShenpi')) && isShowShenpiBtn()">
              <div class="fk-pz">
                <input type="text" placeholder="付款批注" title="付款批注" class="boh-inp" v-model="fukuanPizhu">
              </div>
            </div>
            <div class="main v-fabu-btn" v-if="isShowShenpiBtn()">
              <div v-if="proc.actRuTask && proc.actRuTask.taskDefKey">
                <div v-for="(node, iNode) in nodes.map[proc.actRuTask.taskDefKey].shenpiBtns" :key="iNode" class="c">
                  <div v-if="node.type === 'unPass'" class="sx d-boh">
                    <input type="text" placeholder="请填写驳回申请的原因" title="驳回申请的原因" class="boh-inp" v-model="bohuiYuanyin">
                    <button class="btn new-t-btn c btn-cancel boh" @click="shenpiSubmit(false)">
                      <img alt="" src="../assets/imgs/fail1.svg" width="20" height="20">
                      <p>驳回申请</p>
                      <p class="m-hide">，重填表单</p>
                    </button>
                  </div>
                  <div v-else-if="node.type === 'pass' && (isTaskDefKey('chunaFukuan') || isTaskDefKey('fbaCaigouquerenShenpi'))" class="sx d-boh d-cw-sp-btn">
                    <input type="text" placeholder="备注付款账号" title="付款账号" class="boh-inp" v-model="beizhuFukuanZhanghao" @click.stop="showItemListPayAccount()">
                    <button class="btn new-t-btn c" @click="shenpiSubmit()"><img alt="" src="../assets/imgs/ok2.svg" width="20" height="20">已付款</button>
                    <slide-x-left-transition>
                      <SelectText :list="itemList.payAccount" v-show="isShowList('payAccount')" :callback="setPayAccount"></SelectText>
                    </slide-x-left-transition>
                  </div>
                  <div v-else-if="node.type === 'submitOrderNo'" class="sx d-boh  d-cw-sp-btn">
                    <input type="text" placeholder="请填写样品单号" title="样品单号" class="boh-inp" v-model="yangpindanhao">
                    <button class="btn new-t-btn c" @click="shenpiSubmit()"><img alt="" src="../assets/imgs/ok2.svg" width="20" height="20">已完成</button>
                  </div>
                  <div v-else-if="node.type === 'pass'" class="sx">
                    <button class="btn new-t-btn c" @click="shenpiSubmit()"><img alt="" src="../assets/imgs/ok2.svg" width="20" height="20">审批通过</button>
                  </div>
                  <div v-else-if="node.type === 'submit'" class="sx">
                    <button class="btn new-t-btn c" @click="formSubmit"><img alt="" src="../assets/imgs/ok2.svg" width="20" height="20">提交</button>
                  </div>
                </div>
              </div>
              <div v-else class="sx">
                <button class="btn new-t-btn c" @click="formSubmit"><img alt="" src="../assets/imgs/ok2.svg" width="20" height="20">提交</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ImgViewer ref="imgViewer"></ImgViewer>
  </div>
</template>

<script>
import SelectUser from "@/components/SelectUser";
import SelectBumen from "@/components/SelectBumen";
import SelectCurrency from "@/components/SelectCurrency";
import SelectText from "@/components/SelectText";
import CacheUser from "@/assets/models/CacheUser";
import ProcInfo from "@/assets/models/ProcInfo";
import ProcNodesInfo from "@/assets/models/ProcNodesInfo";
import FbaFormFields from "@/assets/models/FbaFormField";
import ServerAccountList from "@/assets/models/ServerAccountList";
import util from "@/util";
// 插件
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-cn';
import ImgViewer from "../components/ImgViewer";
import print from 'vue-print-nb'
// 图片
import nodeStatusIconUnderway from '@/assets/imgs/todo.svg'
import nodeStatusIconDone from '@/assets/imgs/done.svg'
import nodeStatusIconTodo from '@/assets/imgs/round1.svg'
import userUnLoginImg from '@/assets/imgs/unlogin.svg'
import { avatarColor, avatarInitial } from '@/utils/avatar'
import svgFile from '@/assets/imgs/file2.svg'
import ProcForm from "@/assets/models/ProcForm";
import CurrencyInfo from "@/assets/models/CurrencyInfo";

import "../assets/styles/shenpi.css";
import "../assets/styles/shenpi-m.css";

export default {
  data() {
    return {
      proc: {},
      isTaskChuliMode: false,
      isEditMode: false,
      currencys: [],
      curShowList: '',
      itemList: {},
      chaosongUsername: '',
      chaosongsUsername: '',
      nodes: ProcNodesInfo,
      nodeShowByProc: [],
      isShowDatePicker: false,
      err: {},
      errMsg: {},
      isFormValid: false,
      FbaFormFields: FbaFormFields,
      curEditFieldIndex: 0,
      curEditFieldKey: '',
      bohuiYuanyin: '',
      beizhuFukuanZhanghao: '',
      fukuanPizhu: '',
      yangpindanhao: '',
      backUrlName: '',
      // 供模板在「既无头像也无姓名」时兜底（原本写死在 getUserImg 里，现改为模板分支）
      userUnLoginImg,
      printObj: {
        id: "print-content",
        popTitle: '.',
      }
    };
  },
  props: [],
  components: { SelectUser, DatePicker, SelectBumen, SelectCurrency, SelectText, ImgViewer },
  directives: { print },
  computed: {
    user() {
      return this.$store.state.user
    },
    curUserBumen() {
      if (!this.user)
        return null
      let bumen = this.user.groups.find(g => {
        return g.type === '部门'
      })
      return bumen ? bumen.id : null
    },
    isShowEditBtn() {
      let isSuperAdmin = this.user && this.user.groups && this.user.groups.find(item => item.name === '超级管理员')
      return !this.isEditMode && isSuperAdmin;
    }
  },
  methods: {
    // 无头像兜底：与 components/User.vue 同源（@/utils/avatar），保证同一个人全站同色
    avatarColor,
    avatarInitial,
    openImgViewer(i) {
      let attachment = Array.from(this.proc.data.fujians, item => this.img(item));
      this.$refs.imgViewer.init(attachment, i);
    },
    fdate(date, format) {
      return util.formatDate(date, format)
    },
    // 供应链采购中不显示收款单位账号开户行，直至采购完成发起付款申请
    // 周期结算 - 服务器结算 不显示
    // 工资、社保、公积金 不显示
    isCanShowPayFields() {
      let title = this.proc.data.title;
      let type = this.proc.data.subTitle;
      if (title === '付款申请' && (type === '工资' || type === '社保' || type === '公积金'))
        return false;
      let task = this.proc.actRuTask;
      if (!task && type !== '供应链采购') return true;
      if (title === '周期结算') return false;
      if (type !== '供应链采购') return true;
      let i = ProcNodesInfo.keys.indexOf('tianxieForm');
      let taskKey = task && task.taskDefKey;
      if (this.proc.isEnd) return true;
      let ti = ProcNodesInfo.keys.indexOf(taskKey);
      return ti >= i;
    },
    getUserList() {
      if (!this.chaosongUsername) return this.itemList.users;
      // let res = [];
      // this.itemList.users.forEach(item => {
      //   if (item.id.indexOf(this.chaosongUsername) !== -1) res.push(item);
      // });
      // return res;
      return []
    },
    findAndSetChaosongUser() {
    },
    isShowList(listName) {
      return this.curShowList === listName
    },
    setZi(bumen) {
      this.$get('/sp/id/get', { bumen: bumen }, res => {
        this.proc.data.zi = res
      })
    },
    jineChange() {
      let jine = this.proc.data.jine
      jine = util.toFloat(jine)
      jine = util.toFiexd(jine);
      this.proc.data.jine = jine;
      var jineDaxie = util.moneyUpperCase(jine);
      this.$set(this.proc.data, 'jineDaxie', jineDaxie)
      this.validForm();
    },
    closeDialog(reloadMainData = false) {
      this.$('.d-dialog.animate-left-in').removeClass('active')
      let self = this;
      setTimeout(() => {
        self.$router.push({
          // path: '/sp',
          name: self.backUrlName || '审批系统',
          params: {
            reloadData: reloadMainData
          }
        })
      }, 300)
    },
    getStatusImg(node) {
      let task = this.proc.actRuTask;
      if (this.proc.isEnd) return nodeStatusIconDone;
      if (!this.proc.procInstId) return nodeStatusIconTodo;

      let i = ProcNodesInfo.keys.indexOf(node);
      let taskKey = task && task.taskDefKey;
      let ti = ProcNodesInfo.keys.indexOf(taskKey);
      return ti > i ? nodeStatusIconDone : (ti === i ? nodeStatusIconUnderway : nodeStatusIconTodo)
    },
    isNodeTodo(node) {
      return this.getStatusImg(node) !== nodeStatusIconDone
    },
    // 只负责「有头像就给出完整地址」；没有头像返回空串，由模板决定退化成姓名首字还是未登录图
    getUserImg(field) {
      let img = this.proc && this.proc.data && this.proc.data[field] && this.proc.data[field].img;
      return img ? (this.baseURL + img) : '';
    },
    isShowJiedian() {
      return true
    },
    getUsername(field) {
      return this.proc && this.proc.data && this.proc.data[field] && this.proc.data[field].name || ''
    },
    showItemList(listKey, donotLoadData = false, isListShowKey) {
      if (!isListShowKey) isListShowKey = listKey
      let showList = () => {
        this.curShowList = isListShowKey;
      }
      if (!listKey || !this.isEditMode) return
      // 如果没有数据 则先加载数据
      if (!this.itemList[listKey] && !donotLoadData) {
        if (listKey === 'serverAccount') {
          this.itemList[listKey] = ServerAccountList;
          showList()
          return
        }
        let node = ProcNodesInfo.find('userKey', listKey);
        let groupId;
        if (node) groupId = node.groupId
        else {
          switch (listKey) {
            case 'users':
              groupId = ''
          }
        }
        this.$get('/sp/group/user', { groupId: groupId }, res => {
          this.itemList[listKey] = res
          showList()
        })
      } else
        showList()
    },
    showItemListPayAccount(prevShowListKey) {
      let listKey = 'payAccount'
      if (!prevShowListKey) prevShowListKey = listKey
      if (!this.itemList[listKey])
        this.$get('/sp/user/pay-account', { username: this.user.name }, res => {
          let accounts = Array.from(res, item => item.account)
          this.itemList[listKey] = accounts;
          this.curShowList = prevShowListKey
        });
      else
        this.curShowList = prevShowListKey
    },
    setPayAccount(val) {
      this.beizhuFukuanZhanghao = val;
      this.curShowList = ''
    },
    setUser(user) {
      console.log('set user:', user)
      if (!this.curShowList) return
      // startUser-1
      let userKey = this.curShowList.replace(/-\d/, '')
      this.proc.data[userKey] = user
      this.curShowList = ''
      this.validForm()
    },
    init() {
      let procInfo = this.findProcInfo();
      let nodeInfoList = [];
      procInfo && ProcNodesInfo.all.forEach(nodeInfo => {
        let findNodeInfo = procInfo.node.find(nodeKey => {
          return nodeKey === nodeInfo.key
        })
        if (findNodeInfo)
          nodeInfoList.push(nodeInfo)
      })
      this.nodeShowByProc = nodeInfoList
      if (!this.isEditMode) {
        let self = this
        let currencyCode = util.getCurrencyCode(this.proc.data.currency);

        let moneyFormat = function (key) {
          let keys = key.split('.')
          if (keys.length === 1) {
            // proc.data.jine
            if (util.notEmpty(self.proc.data[keys[0]]))
              self.proc.data[keys[0]] = util.toFiexd(self.proc.data[keys[0]], currencyCode)
          } else {
            let data = self.proc.data[keys[0]];
            if (util.notEmpty(data)) {
              if (data instanceof Array) {
                // proc.data.caigous[0].jine
                data.forEach((item, i) => {
                  let val = self.proc.data[keys[0]][i][keys[1]]
                  if (util.notEmpty(val))
                    self.proc.data[keys[0]][i][keys[1]] = util.toFiexd(val, currencyCode)
                })
              } else {
                // proc.data.caigou.jine
                let val = self.proc.data[keys[0]][keys[1]]
                if (util.notEmpty(val))
                  self.proc.data[keys[0]][keys[1]] = util.toFiexd(val, currencyCode)
              }
            }
          }
        }

        moneyFormat('jine')
        moneyFormat('caigous.danjia')
        moneyFormat('caigous.heji')
        moneyFormat('caigous.yunfei')
        moneyFormat('yongtus.jine')
        moneyFormat('yuanjiekuan')
        moneyFormat('yingtuikuan')
        moneyFormat('kuanxiangsGz.jine')
        moneyFormat('yunfeijine')
        moneyFormat('jineheji')
      }
      this.proc.data.jineDaxie = util.moneyUpperCase(this.proc.data.jine)
      if (!this.proc.data.currency) this.proc.data.currency = '人民币'
    },
    isImg(url) {
      return util.isImg(url)
    },
    getFujianShowSrc(url) {
      return this.isImg(url) ? this.oss + url : svgFile;
    },
    openDatePicker() {
      if (this.isEditMode) this.isShowDatePicker = true
    },
    isShowBumenListByIndex() {
      return true
    },
    isTaskName(taskName) {
      return this.proc.actRuTask && this.proc.actRuTask.name === taskName
    },
    isTaskDefKey(taskDefKey) {
      return this.proc.actRuTask && this.proc.actRuTask.taskDefKey === taskDefKey
    },
    isShowNode(nodeKey) {
      let bumen = this.proc.data.bumen;
      switch (nodeKey) {
        case 'zongcaiShenpi':
          return bumen === '人力资源部'
        case 'yunyingjingliShenpi':
          return bumen === '消费者业务5部'
        case 'zongjingbanShenpi':
          return CurrencyInfo.isNeedApprove(this.proc.data.jine, this.proc.data.currency, bumen)
        case 'zhuguanQueren':
          return bumen === '产品部'
        case 'zhuguanShenpi':
          return this.proc.data.subTitle === '样品采购' ? CurrencyInfo.computeRealMoney(this.proc.data.jine, this.proc.data.currency) > 150 : true;
        default:
          return true
      }
    },
    addChaosongsUser(user) {
      if (!this.proc.data.chaosongsUser)
        this.$set(this.proc.data, 'chaosongsUser', [])
      let index = this.proc.data.chaosongsUser.findIndex(csUser => csUser.name === user.name)
      if (index !== -1)
        this.proc.data.chaosongsUser.splice(index, 1)
      console.log('cs index ', index)
      this.proc.data.chaosongsUser.push(user)
    },
    removeChaosongsUser(i) {
      this.proc.data.chaosongsUser.splice(i, 1)
    },
    addChaosongsUserByName() {
      if (this.chaosongsUsername && this.itemList.users) {
        let user = this.itemList.users.find(user => {
          return user.name === this.chaosongsUsername
        })
        if (user) {
          this.addChaosongsUser(user)
          this.chaosongsUsername = ''
        } else
          this.$msg('没有找到该用户，请输入完整的用户名重试', 'error')
      }
    },
    closeTip() {
      console.log('todo -> close tip ')
      this.curShowList = ''
      this.setEditFieldValue()
    },
    filterChaosongsUser() {
      if (!this.chaosongsUsername)
        return this.itemList.users
      if (!this.itemList.users) return []
      return this.itemList.users.filter(user => user.id.indexOf(this.chaosongsUsername) !== -1)
    },
    updateNowChaosongsUsername(event,) {
      this.chaosongsUsername = event.target.value
    },
    fileChange() {
      let file = event.currentTarget.files[0];
      event.currentTarget.value = ''
      this.uploadFujian(file)
    },
    uploadFujian(file) {
      if (!this.canUploadFujian()) return
      let self = this;
      this.$upload('/sp/fj/upload', { file: file, userId: this.user.id }, res => {
        self.proc.data.fujians.push(res.url)
        this.updateAttachment()
      })
    },
    canUploadFujian() {
      if (this.isEditMode) return true
      if (this.isTaskDefKey('chunaFukuan') && this.user.name === '廖伟君') return true
      if (this.proc.isCC) return true
    },
    showBumenSelectorAndLoad(listKey) {
      if (!this.isEditMode) return;
      let self = this;

      function setItemList() {
        if (!self.itemList[listKey]) {
          // let bumenIds = Array.from(self.itemList.bumens, bumen => bumen.id);
          // self.itemList[listKey] = bumenIds;
          self.itemList[listKey] = self.itemList.bumens
        }
        self.curShowList = listKey
      }

      if (!this.itemList.bumens) {
        this.$get('/sp/group/bumen', { type: '部门' }, res => {
          self.itemList.bumens = res;
          setItemList()
        })
      } else
        setItemList()
    },
    setBumenAndLoadZhuguan(bumen) {
      this.proc.data.bumen = bumen.id
      this.curShowList = ''

      if ('人力资源部' === bumen.id) this.$set(this.proc.data, 'zongcaiUser', CacheUser.zongcai);
      if ('消费者业务5部' === bumen.id) this.$set(this.proc.data, 'yunyingjingliUser', CacheUser.yunyingjingli);
    },
    findProcInfo() {
      return ProcInfo.find(this.proc.data.title, this.proc.data.subTitle);
    },
    formSubmit() {
      let procInfo = this.findProcInfo();
      if (!procInfo) {
        this.$msg('流程未启用，请联系管理员开启', 'error');
        return
      }
      this.isFormValid = true
      if (!this.validForm()) {
        this.$msg('请填写必填项', 'error')
        return
      }
      let submitUrl = this.proc.procInstId ? procInfo.apiReSubmitForm : procInfo.apiSubmitForm
      let postData = util.clone(this.proc.data);
      if (this.proc.procInstId) {
        postData.taskId = this.proc.actRuTask.id;
      }
      this.$post(submitUrl, postData, () => {
        this.closeDialog(true)
      })
    },
    shenpiSubmit(isTongguo = true) {
      let taskKey = this.proc.actRuTask.taskDefKey;
      let apiSubmit = ProcNodesInfo.find('key', taskKey).apiSubmit
      let postData = {
        userId: this.user.name,
        taskId: this.proc.actRuTask.id,
        tongguo: isTongguo,
        procInstId: this.proc.procInstId,
        executionId: this.proc.actRuTask.executionId,
        bohuiYuanyin: this.bohuiYuanyin,
        beizhuFukuanZhanghao: this.beizhuFukuanZhanghao,
        fukuanPizhu: this.fukuanPizhu
      };
      if (taskKey === 'chunaFukuan') postData.fujians = this.proc.data.fujians;
      if (taskKey === 'huitianyangpindanhao') postData.yangpindanhao = this.yangpindanhao;
      // 付款申请-物流费结算-结算款项 备注付款账号
      if (this.proc.data.title === '付款申请' && this.proc.data.subTitle === '物流费结算' && taskKey === 'chunaFukuan')
        postData.kuanxiangsGz = Array.from(this.proc.data.kuanxiangsGz, item => {
          item.jine = util.toFiexd(item.jine)
          return item
        })
      util.loadBegin();
      this.$post(apiSubmit, postData, () => {
        util.loadClose()
        this.closeDialog(true)
      })
    },
    validForm() {
      let data = this.proc.data;
      let errTmp = {};
      let errMsgTmp = {};
      let procInfo = this.findProcInfo();
      procInfo.needValidFormField && procInfo.needValidFormField.forEach(field => {
        util.reg.notEmpty(data, field, errTmp, errMsgTmp)
      })
      if (this.proc.data.bumen === '人力资源部')
        util.reg.notEmpty(data, 'zongcaiUser.name', errTmp, errMsgTmp)
      if (this.proc.data.bumen === '消费者业务5部')
        util.reg.notEmpty(data, 'yunyingjingliUser.name', errTmp, errMsgTmp)
      this.err = Object.assign(this.err, errTmp)
      this.errMsg = Object.assign(this.errMsg, errMsgTmp)
      this.$forceUpdate()
      return !util.reg.hasError(this.err);
    },
    baoxiaoHeji() {
      // 计算报销合计金额
      let jine = 0;
      this.proc.data.yongtus && this.proc.data.yongtus.forEach(item => {
        let p = parseFloat(item.jine);
        p = isNaN(p) ? '' : p.toFixed(2);
        item.jine = p;
        jine += (item.jine - 0);
      });
      this.proc.data.jine = jine.toFixed(2);
      this.proc.data.jineDaxie = util.moneyUpperCase(this.proc.data.jine);
      let yjk = this.proc.data.yuanjiekuan;
      yjk = parseFloat(yjk);
      if (isNaN(yjk)) {
        this.proc.data.yuanjiekuan = '';
        this.proc.data.yingtuikuan = '';
      } else {
        this.proc.data.yuanjiekuan = yjk.toFixed(2);
        this.proc.data.yingtuikuan = (jine - yjk).toFixed(2);
      }
      this.validForm()
    },
    addYongtu() {
      this.proc.data.yongtus.push({
        name: '',
        jine: ''
      })
    },
    isEditField(i, key) {
      return i == this.curEditFieldIndex && key == this.curEditFieldKey;
    },
    setEditFieldValue() {
      let data = this.proc.data, i = this.curEditFieldIndex, key = this.curEditFieldKey;
      if (typeof i === 'number' && key) {
        let formField = FbaFormFields[data.title][data.subTitle].find(item => {
          return item.key === key;
        });
        if (!formField) return;
        let fnFormat = formField.format;
        let val = fnFormat ? fnFormat(this.editFieldValue, data.caigous[i]) : this.editFieldValue;
        data.caigous[i][key] = val;
        this.computeYpcgJine();
      } else {
        data[key] = this.editFieldValue;
      }
      this.curEditFieldIndex = null;
      this.curEditFieldKey = null;
      this.editFieldValue = null;
    },
    editField(i, key) {
      if (!this.isEditMode) return;
      this.setEditFieldValue()
      this.$nextTick(() => {
        let $div = this.$(event.currentTarget).children();
        let w = $div.width(), h = $div.height();
        if (typeof i === 'number')
          this.editFieldValue = this.proc.data.caigous[i][key];
        else
          this.editFieldValue = i[key]
        this.curEditFieldIndex = i;
        this.curEditFieldKey = key;
        this.$nextTick(() => {
          if (typeof i !== 'number')
            i = 'other'
          let $textarea = this.$(`#textarea-${i}-${key}`);
          $textarea.width(w)
          $textarea.height(h)
          $textarea.focus();
        })
      })
    },
    addCaigouItem() {
      let cg = util.clone(ProcForm.caigou);
      cg.xuhao = this.proc.data.caigous.length + 1;
      this.proc.data.caigous.push(cg);
    },
    computeYpcgJine() {
      let sumYunfei = 0;
      let sumJine = 0;
      let cgs = this.proc.data.caigous;
      let subTitle = this.proc.data.subTitle;
      for (let i = 0; i < cgs.length; i++) {
        if (subTitle === '样品采购') {
          cgs[i].danjia = util.toFloat(cgs[i].danjia);
          cgs[i].yunfei = util.toFloat(cgs[i].yunfei);
          cgs[i].heji = cgs[i].shuliang * cgs[i].danjia + cgs[i].yunfei;
          cgs[i].heji = util.toFloat(cgs[i].heji);
          sumYunfei += cgs[i].yunfei;
          sumJine += cgs[i].heji;
        } else if (this.isSubTitle('FBA备货申请', '发货申请')) {
          let sl = parseInt(cgs[i].shuliang);
          cgs[i].shuliang = isNaN(sl) ? 0 : sl;
          cgs[i].danjia = util.toFloat(cgs[i].danjia);
          cgs[i].yunfei = util.toFloat(cgs[i].yunfei);
          cgs[i].heji = util.toFloat(cgs[i].shuliang * cgs[i].danjia + (cgs[i].yunfei - 0));

          sumJine += cgs[i].heji
          sumYunfei += cgs[i].yunfei - 0;
        } else if (subTitle === 'FBA确认申请') {
          let sl = parseInt(cgs[i].shuliang);
          cgs[i].shuliang = isNaN(sl) ? 0 : sl;
          cgs[i].danjia = util.toFiexd(cgs[i].danjia);
          cgs[i].fujiafei = util.toFiexd(cgs[i].fujiafei);
          cgs[i].yuguyunfei = util.toFiexd(cgs[i].yuguyunfei);

          sumJine += util.toFiexd(cgs[i].shuliang * cgs[i].danjia + (cgs[i].yuguyunfei - 0) + parseFloat(cgs[i].fujiafei)) - 0
          sumYunfei += cgs[i].yuguyunfei - 0;
        } else throw new Error("");
      }
      this.proc.data.jineheji = util.toFloat(sumJine);
      if (subTitle === '样品采购') {
        this.proc.data.yunfeijine = util.toFloat(sumYunfei);
        this.proc.data.jine = util.toFiexd(sumJine);
      } else if (this.isSubTitle('FBA备货申请', '发货申请')) {
        this.proc.data.yunfeijine = util.toFloat(this.proc.data.yunfeijine);
        this.proc.data.jine = util.toFiexd(sumJine + this.proc.data.yunfeijine);
      }
      this.jineChange(this.proc.data.jine);
    },
    setServerAccount(serverAccount) {
      this.proc.data.shoukuan = serverAccount.shoukuan;
      this.proc.data.zhanghao = serverAccount.zhanghao;
      this.proc.data.serverZhanghao = serverAccount.account;
      this.proc.data.fuwushang = serverAccount.server;
      this.proc.data.yuanyin = serverAccount.yuanyin;
      this.curShowList = '';
    },
    isShowShenpiBtn() {
      // 需要审批
      if (this.proc.actRuTask && this.proc.actRuTask.userId === this.user.name) return true
      // 新建流程需要提交
      if (!this.proc.procInstId) return true
    },
    setKxBumen(bumen) {
      let i = this.$(event.currentTarget).parents('[index]').attr('index')
      this.proc.data.kuanxiangsGz[i].bumen = bumen.id;
      this.curShowList = ''
      this.validForm()
    },
    setKxPayAccount(payAccount) {
      let i = this.$(event.currentTarget).parents('[index-kx]').attr('index-kx')
      this.proc.data.kuanxiangsGz[i].payAccount = payAccount;
      this.curShowList = ''
      this.validForm()
    },
    setZhouqijiesuanKxBumen(bumen) {
      let i = this.$(event.currentTarget).parents('[index]').attr('index')
      this.proc.data.kuanxiangs[i].bumen = bumen.id;
      this.curShowList = ''
      this.validForm()
    },
    addKuanxiang() {
      this.proc.data.kuanxiangs.push({
        name: '',
        jine: '',
        bumen: ''
      })
    },
    addKuanxiangGz() {
      this.proc.data.kuanxiangsGz.push({
        payAccount: '',
        jine: '',
        bumen: ''
      })
    },
    jiesuanHejiGz() {
      // 计算结算款项合计金额
      let jine = 0;
      this.proc.data.kuanxiangsGz && this.proc.data.kuanxiangsGz.forEach(item => {
        item.jine = util.toFiexd(item.jine);
        jine += (item.jine - 0);
      });
      this.proc.data.jine = util.toFiexd(jine);
      this.$nextTick(() => {
        this.jineChange()
      })
    },
    addcaigouQingdanGyl() {
      this.proc.data.caigouQingdanGyl.push({
        name: '',
        danjia: '',
        shuliang: ''
      })
    },
    addFujian() {
      this.$('#file').click();
    },
    delFj(i) {
      if (this.isEditMode)
        this.proc.data.fujians.splice(i, 1)
      else
        this.updateAttachment(true, i)
    },
    updateAttachment(isDelete = false, attachmentIndex) {
      // 仅抄送的情况下可以更新附件
      if (!this.proc.isCC) return
      let self = this, _layerConfirmId;

      function postAttachment() {
        self.$post('/sp/fj/update', {
          procInstId: self.proc.procInstId,
          fujians: self.proc.data.fujians
        }, () => {
          window.layer.close(_layerConfirmId);
        })
      }

      if (isDelete)
        _layerConfirmId = window.layer.confirm('删除后不可恢复，确认删除？', () => {
          self.proc.data.fujians.splice(attachmentIndex, 1)
          postAttachment()
        })
      else
        postAttachment()
    },
    jiesuanHeji() {
      // 计算结算款项合计金额
      let jine = 0;
      this.proc.data.kuanxiangs && this.proc.data.kuanxiangs.forEach(item => {
        item.jine = util.toFloat(item.jine)
        jine += item.jine - 0;
      });
      this.proc.data.jine = jine.toFixed(2);
      this.proc.data.jineDaxie = util.moneyUpperCase(this.proc.data.jine);
      this.validForm()
    },
    isProc(title, subTitle) {
      return title === this.proc.data.title && subTitle === this.proc.data.subTitle
    },
    isSubTitle(...subTitle) {
      return subTitle.indexOf(this.proc.data.subTitle) !== -1;
    },
    yujieHeji() {
      console.log('todo yujieHeji')
    },
    yusuanHeji() {
      console.log('todo yusuanHeji')
    },
    /**
     * 改变模式为抄送模式，仅用于更新附件
     */
    changeModeCC() {
      this.proc.isCC = true
      this.$forceUpdate()
      this.$msg('已切换编辑模式，仅支持编辑附件')
    }
  },
  mounted() {
    window.$dialogProc = this;
    document.onpaste = e => {
      if (!e.clipboardData || !e.clipboardData.items || !['查看记录', '流程'].includes(window.$dialogProc.$route.name)) {
        return;
      }
      let file = false;
      for (var i = 0, len = e.clipboardData.items.length; i < len; i++) {
        var item = e.clipboardData.items[i];
        if (/image/.test(item.type)) {
          file = item.getAsFile();
        }
      }
      console.log('pre upload file: ', file);
      if (file)
        this.uploadFujian.call(this, file)
    }
  },
  created: function () {
    let id = parseInt(this.$route.params.id);
    let title = this.$route.params.title;
    let subTitle = this.$route.params.subTitle;
    let isCC = this.$route.params.isCC;
    this.backUrlName = this.$route.params.backUrlName;
    if (!id && !(title || subTitle)) {
      this.$router.push('/sp')
      return
    }

    console.log('dialog task created id: ', id, title, subTitle)
    document.title = id ? '流程查看' : '流程创建'
    if (id) {
      let self = this;
      this.$get('/sp/process', { procId: id }, proc => {
        if (!proc) {
          self.$layer.msg('流程不存在，可能已删除或已完成')
          setTimeout(() => self.$router.push('/sp'), 3000)
        }
        self.proc = proc
        self.proc.isCC = isCC
        if (self.isTaskDefKey('tianxieForm') || self.isTaskDefKey('tianxieCaigouForm'))
          self.isEditMode = true
        self.init()
      })
    } else {
      let procInfo = ProcInfo.find(title, subTitle)
      let model = util.clone(procInfo.useForm)
      model.title = title
      model.subTitle = subTitle
      model.bumen = this.curUserBumen
      this.setZi(this.curUserBumen)
      model.userId = this.user.name
      model.startUser = {
        name: this.user.name,
        img: this.user.img
      }
      // if(subTitle === '供应链采购')
      //   model.startUser
      model.createDate = util.formatDate(new Date().getTime())
      this.proc = {
        actRuTask: null,
        data: model
      }
      this.setBumenAndLoadZhuguan({ id: this.proc.data.bumen })
      this.isEditMode = true
      this.init()

      this.$get('/sp/group/zhuguan', { group: util.getBumenByZhuguan(this.user) }, res => {
        this.proc.data.zhuguanUser = {
          name: res[0].name,
          img: res[0].img,
        }
      })
    }
  },
  destroyed() {
  },
  beforeRouteUpdate(to, from, next) {
    // 在当前路由改变，但是该组件被复用时调用
    // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
    // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
    // 可以访问组件实例 `this`
    console.log('dialog proc 被复用: ', next)
    console.log('from:', from)
    console.log('to:', to)
    console.log('router:', this.$router)
    next()
  },
};
</script>
<style scoped>
.daxie > div:nth-child(even), .names, .tablest .titles, .bootmLefts > div, .dibu > div > p, .hao, .title, .day p, .bodylen, .bootmTops div, .fu, label, .dibu p, .fj .titles,
.k {
  font-family: 'kaiti', serif;
  color: #01639c;
  font-size: 17px;
}

.names {
  font-size: 32px;
  padding-top: 20px;
  letter-spacing: 4px;
}

.d-date {
  flex-direction: column;
  align-items: center;
}

.mx-datepicker {
  width: 248px;
  height: 0;
  overflow: hidden;
}

.cs-img-name {
  padding: 3px 5px 3px 0;
  border: 1px solid rgb(223, 225, 230);
  border-radius: 3px;
  margin: 0 5px 5px 0;
  animation: v-left-in .3s forwards;
  -webkit-animation: v-left-in .3s forwards;
}

.proc .jd {
  animation: v-left-in .3s forwards;
  -webkit-animation: v-left-in .3s forwards;
}

.cs-img-name img {
  margin-left: 5px;
}

.cs-img-name .profile {
  margin-right: 5px;
}

/* 无头像兜底：尺寸沿用全局 .profile（25px 圆，与 User.vue 的 .name-avatar 一致），这里只补居中与字色 */
.name-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.d-cs-user {
  flex-wrap: wrap;
  justify-content: flex-start;
}

.d-inp-cs {
  border-bottom: 1px solid #e1e3e7;
  width: 100px;
  margin: 0 5px 5px 0;
  height: 31px;
  position: relative;
  border-radius: 3px;
}

.d-inp-cs > input {
  width: 100%;
  height: 100%;
  border: unset;
  margin: 0;
  padding-right: 23px;
}

.d-inp-cs > img {
  position: absolute;
  right: 7px;
  top: 6px;
}

.bumen-name-btn > span,
.day,
.bumen > p,
.zihao {
  height: 25px;
  line-height: 25px
}

.proc img.node-status-img {
  background: unset;
}

.d-boh {
  height: 40px;
}

.v-fabu-btn button.btn {
  margin: 0;
}

.d-cw-sp-btn > button {
  position: absolute;
  right: 3px;
}

.d-cw-sp-btn > input {
  padding-right: 115px;
}

.bodylen {
  width: 20px;
  writing-mode: tb;
  font-size: 15px;
}

.jd .d-active {
  width: 33px;
}

.proc .n > div.no-user-key {
  border: unset;
  cursor: unset;
}

.proc .n > div.no-user-key:hover {
  background-color: unset;
}

.proc .n > div.no-user-key > img, .proc .n > div.no-user-key > p {
  display: none
}

.tablest .titles.ytname {
  height: auto;
}

.v-fabu-btn .d-boh {
  max-width: 400px;
  width: auto;
}

.p-a-inp {
  width: auto;
}

.a-btn {
  padding: 4px 6px;
}

@media only screen and (max-width: 749px) {
  .daxie > div:nth-child(even), .tablest .titles, .bootmLefts > div, .dibu > div > p, .hao, .title, .day p, .bodylen, .bootmTops div, .fu, label, .dibu p, .fj .titles, .k {
    font-size: 15px;
  }

  .d-content header {
    padding: 0;
    height: 66px;
  }

  .proc,
  .proc .jd {
    flex-direction: column;
  }

  .proc {
    margin-top: 20px;
    width: calc(100% - 20px);
  }

  .proc .e {
    flex-direction: row;
  }

  .proc .e > div:first-child {
    margin-bottom: 0;
  }

  .proc .e > div:last-child {
    width: auto;
  }

  .proc .n {
    height: 50px;
    display: flex;
    margin: 2px 0;
  }

  .sub-title-inp {
    width: 150px;
  }

  .proc .n .l {
    width: 1px;
    height: 100%;
    padding-left: 13px;
  }

  .proc .n .l::after {
    right: 0;
    left: unset;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 1px;
  }

  .proc .n > div:last-child {
    width: auto;
    flex-direction: row;
    min-height: unset;
    padding: 3px 5px;
    height: 25px;
    margin-top: 5px;
    margin-left: 10px;
  }

  .d-user > p {
    min-height: unset;
  }

  .proc img.profile {
    margin-bottom: unset;
    margin-right: 5px;
  }

  .proc .jd:first-child .n .l {
    padding-left: 13px;
  }

  .d-active {
    justify-content: flex-start;
  }

  .main.v-fabu-btn {
    margin-bottom: 20px;
    overflow: visible;
  }

  .d-user .icon-jiantou,
  .d-cs-user .icon-jiantou {
    margin-left: 5px;
    margin-top: 0;
  }

  .headerLefts {
    flex-wrap: wrap;
  }

  .headerLefts > div {
    width: 100%;
    justify-content: center;
  }

  .body > .flexLeft {
    display: none;
  }

  .invoicMain {
    padding: 0 0 10px;
    width: 100%;
  }

  .invoiceHeader {
    margin: 0 3px;
  }

  .body {
    display: block;
    width: 100%;
    overflow-x: auto;
  }

  .body > .d-form {
    width: 750px;
    padding: 10px 0;
  }

  .v-fabu-btn > div {
    flex-wrap: wrap;
  }

  .d-cs {
    margin: 3px;
  }

  .v-fabu-btn .btn-cancel.boh,
  .d-cw-sp-btn button {
    width: auto;
  }

  .v-fabu-btn > div > div.c,
  .v-fabu-btn > div > div.c > .sx {
    width: 100%;
  }

  .d-boh button.boh {
    height: 34px;
  }

  .fk-pz {
    padding-right: 0;
  }

  .fk-pz input {
    max-width: unset;
  }

  .sx.d-boh .boh-inp {
    padding-right: 135px;
  }

  .tablest .titles, .neiron {
    height: 30px;
  }

  .titles.d-checkbox, .d-checkbox {
    height: auto;
  }

  .biaoge {
    min-height: 30px;
  }
}
</style>
